import styled from "styled-components/macro";

export const StyledRightBarContainer = styled.div`
  &.collapsed {
    overflow: visible;
    *:not(.rightbarcontainer-section, #right, .collapse, .collapse *, .chat, .chat *) {
      display: none;
    }

    #right {
      background: transparent;
      box-shadow: none;
      border-left: 2px solid transparent;

      .collapse {
        left: unset;
        right: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        /* Above the column-resize gutters (z-index 999) so the re-open buttons stay clickable */
        z-index: 1000;

        svg {
          path {
            fill: var(--grey-0);
          }
        }
      }
      .history {
        display: none !important;
      }
    }
  }
  #right {
    background: var(--document-background);
    border-radius: 28px 0 0 28px;
    height: calc(100% - 10px) !important;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 15px;

    .select {
      right: 14px !important;
      top: 8px !important;
      ul {
        body[data-theme-type="dark"] & {
          background-color: var(--menu-color-hover) !important;
        }
        li {
          a {
            &.selected {
              box-shadow: var(--slider-handle-drop-shadow);

              body[data-theme-type="dark"] & {
                background-color: var(--menu-color-active-lightened) !important;
              }
            }

            svg {
              path {
                fill: var(--grey-0) !important;
              }
            }
          }
        }
      }
    }

    .card-sets {
      .card-set {
        .cards {
          .card {
            box-shadow: var(--card-drop-shadow) !important;
            margin-top: 2px;
          }
        }
        .collapsed {
          box-shadow: var(--card-drop-shadow) !important;

          .under-1 {
            box-shadow: var(--card-drop-shadow) !important;
          }
        }
      }
    }

    .collapse {
      position: absolute;
      left: 13px;
      top: 8px;
      cursor: pointer;
      z-index: 1;

      svg {
        path {
          fill: var(--grey-2);
        }
      }

      .collapse-right-bar svg {
        transform: scaleX(-1);
      }
    }

    .history {
      background-color: transparent !important;

      .section-title {
        font-weight: 500 !important;
        text-transform: none !important;
        font-size: 16px !important;
        letter-spacing: unset !important;
        color: var(--grey-0) !important;
        opacity: 1 !important;
        top: 14px !important;
      }
    }

    .chat {
      padding: 10px !important;
    }
  }
`;
